// "FREQ=WEEKLY;INTERVAL=1;BYDAY=SA,MO"
import moment from 'moment-timezone';
export var Frequency;
(function (Frequency) {
    Frequency["DAILY"] = "DAILY";
    Frequency["WEEKLY"] = "WEEKLY";
    Frequency["MONTHLY"] = "MONTHLY";
    Frequency["YEARLY"] = "YEARLY";
})(Frequency || (Frequency = {}));
export var ByDay;
(function (ByDay) {
    ByDay["MO"] = "MO";
    ByDay["TU"] = "TU";
    ByDay["WE"] = "WE";
    ByDay["TH"] = "TH";
    ByDay["FR"] = "FR";
    ByDay["SA"] = "SA";
    ByDay["SU"] = "SU";
})(ByDay || (ByDay = {}));
var SupportedProps;
(function (SupportedProps) {
    SupportedProps["FREQ"] = "FREQ";
    SupportedProps["INTERVAL"] = "INTERVAL";
    SupportedProps["BYDAY"] = "BYDAY";
    SupportedProps["UNTIL"] = "UNTIL";
})(SupportedProps || (SupportedProps = {}));
export default class RRule {
    constructor({ freq, interval, byDay, until, } = {}) {
        this.freq = Frequency.WEEKLY;
        this.interval = 1;
        this.byDay = null;
        this.until = null;
        this.freq = (freq && verifyFrequency(freq)) || this.freq;
        this.interval = interval === null || interval ? interval : this.interval;
        this.byDay = (byDay && verifyByDay(byDay)) || this.byDay;
        this.until = until || this.until;
    }
    changeFreq(freq) {
        this.freq = verifyFrequency(freq);
    }
    changeInterval(interval) {
        this.interval = interval;
    }
    changeByDay(byDay) {
        this.byDay = verifyByDay(byDay);
    }
    changeUntil(until) {
        this.until = until;
    }
    addByDay(byDay) {
        const days = verifyByDay(byDay);
        this.byDay = this.byDay ? this.byDay.concat(days) : days;
    }
    get options() {
        return {
            freq: this.freq,
            interval: this.interval,
            byDay: this.byDay,
            until: this.until,
        };
    }
    toString() {
        const strArray = [];
        if (this.freq) {
            strArray.push(`${SupportedProps.FREQ}=${this.freq}`);
        }
        if (this.interval) {
            strArray.push(`${SupportedProps.INTERVAL}=${this.interval}`);
        }
        if (this.byDay) {
            const byDays = this.byDay.map((byDay) => {
                if (typeof byDay === 'string') {
                    return byDay;
                }
                else {
                    return `${byDay.every}${byDay.byDay}`;
                }
            });
            strArray.push(`${SupportedProps.BYDAY}=${byDays.join(',')}`);
        }
        if (this.until) {
            strArray.push(`${SupportedProps.UNTIL}=${moment(this.until)
                .tz('UTC')
                .format('YYYYMMDDTHHmmss')}Z`);
        }
        return strArray.join(';');
    }
    static fromString(rruleStr, timeZone) {
        const rrule = new RRule({ interval: null });
        const strArray = rruleStr.split(';');
        strArray.forEach((str) => {
            const strSplit = str.split('=');
            const prop = strSplit[0];
            const value = strSplit[1];
            switch (prop) {
                case SupportedProps.FREQ:
                    rrule.changeFreq(verifyFrequency(value));
                    break;
                case SupportedProps.INTERVAL:
                    const interval = parseInt(value, 10);
                    Boolean(interval) && rrule.changeInterval(interval);
                    break;
                case SupportedProps.BYDAY:
                    rrule.changeByDay(verifyByDay(value));
                    break;
                case SupportedProps.UNTIL:
                    rrule.changeUntil(mapUntilToMoment(value, timeZone));
                    break;
                default:
            }
        });
        return rrule;
    }
}
function mapUntilToMoment(until, timeZone) {
    const re = /^(\d{4})(\d{2})(\d{2})(T(\d{2})(\d{2})(\d{2})Z?)?$/;
    const bits = re.exec(until);
    if (!bits) {
        throw new Error('Invalid UNTIL value: ' + until);
    }
    const year = parseInt(bits[1], 10);
    const month = parseInt(bits[2], 10) - 1;
    const day = parseInt(bits[3], 10);
    const hour = parseInt(bits[5], 10) || 0;
    const minute = parseInt(bits[6], 10) || 0;
    const second = parseInt(bits[7], 10) || 0;
    const format = moment
        .utc({ year, month, day, hour, minute, second })
        .format();
    return timeZone ? moment.tz(format, timeZone) : moment(format);
}
function verifyByDay(byDay) {
    const days = typeof byDay === 'string' ? byDay.split(',') : byDay;
    const availableByDay = Object.values(ByDay);
    return days.map((day) => {
        if (availableByDay.includes(day)) {
            return day;
        }
        else if (typeof day === 'string') {
            const every = day.substring(0, day.length - 2);
            const onDay = day.substring(day.length - 2);
            if (availableByDay.includes(onDay) &&
                !isNaN(parseInt(every, 10))) {
                return {
                    every: parseInt(every, 10),
                    byDay: onDay,
                };
            }
        }
        else if (day.every && day.byDay) {
            return day;
        }
        throw new Error('Invalid BYDAY value: ' + byDay);
    });
}
function verifyFrequency(frequency) {
    const availableFrequency = Object.values(Frequency);
    if (availableFrequency.includes(frequency)) {
        return frequency;
    }
    throw new Error('Invalid FREQ value: ' + frequency);
}
//# sourceMappingURL=rrule.js.map